import { SvgIcon, SvgIconProps } from '@mui/material';

export function ArrowRightOutlineIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 16 16'
    >
      <path
        d='M6.97341 12C6.76406 11.9988 6.55733 11.9533 6.36675 11.8667C6.16063 11.7758 5.98502 11.6275 5.8609 11.4396C5.73677 11.2516 5.66937 11.0319 5.66675 10.8067V5.19332C5.66937 4.96808 5.73677 4.74836 5.8609 4.5604C5.98502 4.37243 6.16063 4.22417 6.36675 4.13332C6.60391 4.0213 6.86777 3.97815 7.12826 4.0088C7.38875 4.03944 7.63539 4.14265 7.84008 4.30665L11.2401 7.11332C11.3734 7.21946 11.4811 7.35431 11.5551 7.50782C11.6291 7.66134 11.6675 7.82956 11.6675 7.99998C11.6675 8.17041 11.6291 8.33863 11.5551 8.49215C11.4811 8.64566 11.3734 8.78051 11.2401 8.88665L7.84008 11.6933C7.595 11.8921 7.28896 12.0004 6.97341 12ZM6.97341 5.33332V10.6L10.2134 7.99998L6.97341 5.33332Z'
        fill='#3B3C40'
      />
    </SvgIcon>
  );
}
